// v2：铃铛只留红点角标，点开=AI 面板带上下文（欠账#1 答复；下拉退役）
import { useNotifications } from '../hooks/useNotifications'
import { useNavigate } from 'react-router-dom'

const BellIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
  </svg>
)

export function NotificationBell() {
  const nav = useNavigate()
  const { unreadCount } = useNotifications()

  return (
    <button
      onClick={() => nav('/notifications')}
      className="relative p-2 hover:bg-gray-100 rounded-full transition-colors"
      title="通知中心"
    >
      <BellIcon className={unreadCount > 0 ? "w-5 h-5 text-red-500" : "w-5 h-5 text-gray-500"} />
      {unreadCount > 0 && (
        <span className="absolute -top-0.5 -right-0.5 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[16px] h-4 flex items-center justify-center px-1">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  )
}
